<template>
	<div
		ref="containerRef"
		role="button"
		tabindex="0"
		aria-label="Ampliar imagem"
		class="relative flex size-full items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-inset"
		:data-zoom-available="canZoom"
		@click="emitZoomEvent"
		@keydown="handleZoomKeydown"
	>
		<slot :can-zoom="canZoom" />
	</div>
</template>

<script setup lang="ts">
const emits = defineEmits<{
	(event: 'zoomIn', cords: { x: number; y: number }): void;
}>();
const containerRef = ref<HTMLElement | null>(null);
const canZoom = ref(true);

function emitCenteredZoomEvent() {
	const image = containerRef.value?.querySelector<HTMLImageElement>('img');

	if (!canZoom.value || !image) return;

	const rect = image.getBoundingClientRect();
	if (rect.width <= 0 || rect.height <= 0) return;

	emits('zoomIn', { x: 50, y: 50 });
}

function handleZoomKeydown(event: KeyboardEvent) {
	if (
		event.target !== event.currentTarget ||
		(event.key !== 'Enter' && event.key !== ' ')
	) {
		return;
	}

	event.preventDefault();
	event.stopPropagation();
	emitCenteredZoomEvent();
}

function emitZoomEvent(event: MouseEvent) {
	const container = containerRef.value;
	const targetElement = event.target;

	if (
		!container ||
		!canZoom.value ||
		!(targetElement instanceof HTMLImageElement)
	) {
		return;
	}

	const rect = targetElement.getBoundingClientRect();
	if (rect.width <= 0 || rect.height <= 0) return;
	const mouseX = event.clientX - rect.left;
	const mouseY = event.clientY - rect.top;

	// Calcular a posição em porcentagem
	const percentageX = (mouseX / rect.width) * 100;
	const percentageY = (mouseY / rect.height) * 100;

	emits('zoomIn', {
		x: percentageX,
		y: percentageY
	});
}
</script>
